import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('my-modal', {
    attrs: {
      "title": _vm.t('批量设置预警'),
      "width": 600,
      "data-sign": "inventory_age_set_warn_modal"
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('a-form-model', {
    ref: "formDataRef",
    attrs: {
      "model": _vm.formData
    }
  }, [_c('my-table', {
    attrs: {
      "columns": _vm.columns,
      "data-source": _vm.formData.list,
      "bordered": "",
      "row-key": "product_id"
    },
    scopedSlots: _vm._u([{
      key: "warn",
      fn: function (ref) {
        var record = ref.record;
        var index = ref.index;
        return _c('div', {}, [_c('a-form-model-item', {
          attrs: {
            "prop": "list." + index + ".iba_warning_age",
            "rules": _vm.formDataRule['list.*.iba_warning_age']
          }
        }, [_c('a-input-number', {
          attrs: {
            "max": 9999,
            "min": 0,
            "formatter": _vm.formatter,
            "step": 1
          },
          model: {
            value: record.iba_warning_age,
            callback: function ($$v) {
              _vm.$set(record, "iba_warning_age", $$v);
            },
            expression: "record.iba_warning_age"
          }
        })], 1)], 1);
      }
    }, {
      key: "warehouse_code",
      fn: function (ref) {
        var record = ref.record;
        return _c('div', {}, [record.warehouse_code ? _c('div', [_vm._v(_vm._s(record.warehouse_code) + "[" + _vm._s(record._warehouse_desc) + "]")]) : _c('div', [_vm._v(_vm._s(_vm._f("filterEmpty")('')))])]);
      }
    }])
  })], 1), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('a-button', {
    attrs: {
      "data-permission": "inventory_age_set_warn_modal_cancel",
      "id": "inventory_age_set_warn_modal_cancel",
      "data-sign": "inventory_age_set_warn_modal_cancel",
      "fbu-analyse-name": $t("\u53D6\u6D88")
    },
    on: {
      "click": function ($event) {
        _vm.visible = false;
      }
    }
  }, [_vm._v(_vm._s(_vm.t('取消')))]), _c('a-button', {
    attrs: {
      "data-permission": "inventory_age_set_warn_modal_confirm",
      "id": "inventory_age_set_warn_modal_confirm",
      "type": "primary",
      "data-sign": "inventory_age_set_warn_modal_confirm",
      "fbu-analyse-name": $t("\u63D0\u4EA4")
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v(_vm._s(_vm.t('提交')))])], 1)], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };